module.exports = __webpack_public_path__ + "static/media/0223_IMG_LES_MURS_P21_UNI_CARVAO_CHEVRON.1d5e0732.png";